module.exports = __webpack_public_path__ + "static/media/pricing-icon_free.6b4799c2.svg";